import { backendPostWithoutRefresh } from "./callBackend";

// generic new bank account
export function newBankAccountGeneric(
  source, 
  id, 
  description, 
  accountOwnerAppName, 
  accountOwnerType, 
  accountOwnerId, 
  accountTypeAttribute,
  newAccountType="checking",
  ignoreThen=false,
  ignoreReload=true,
  successCallback,
  errorCallback
) {
  var data = {
      source: source,
      source_id: id,
      description: description,
      account_owner_app_name: accountOwnerAppName,
      account_owner_type: accountOwnerType,
      account_owner_id: accountOwnerId,
      account_type_attribute: accountTypeAttribute,
      new_account_type: newAccountType,
  };
  backendPostWithoutRefresh("/api/bank-account/", data)
  .then((response) => {
    if (response.status === 200 || response.status === 201) {
      // props.addBankAccount(response.data);
      successCallback(response.data);
    } else {
      errorCallback();
    }
  });
};

export function linkBankAccountGenericMulti(
  accountParams,
  indices,
  successCallback,
  errorCallback,
  props=undefined,
) {
  let data = {
      accountParams, // sourceId, description, accountTypeAttribute, source
      indices,
  };
  backendPostWithoutRefresh("/api/bank-account/multi/", data).then(
    (response) => {
      if (response.status === 200 || response.status === 201) {
        if (props !== undefined) {
          props.addNewBankAccounts(response.data.data);
          successCallback();
        } else {
          successCallback(response.data.data);
        }
      } else {
        errorCallback();
      }
    }
  );
};